<template><div></div> </template>

<script>
export default {
  name: "ErrorPayment"
};
</script>

<style scoped></style>
